import { useContext } from 'react';
import { RenderElementProps, ReactEditor, useSlateStatic } from 'slate-react';
import { TagContext } from 'app/state/contexts/TagContext';

export const ExcludeElement = ({ attributes, children, element }: RenderElementProps) => {
  const editor = useSlateStatic();
  const { setSelectedExcludePath } = useContext(TagContext) as any;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      setSelectedExcludePath?.(ReactEditor.findPath(editor, element));
    } catch {
      // Node not findable (mid-edit) — ignore.
    }
  };

  return (
    <span
      {...attributes}
      data-exclude="true"
      onClick={handleClick}
      style={{
        textDecorationLine: 'underline',
        textDecorationStyle: 'dashed',
        textDecorationColor: '#9a99a0',
        backgroundColor: 'white',
        borderRadius: '2px',
      }}
      title="Undantaget från fakta"
    >
      {children}
    </span>
  );
};
